import React, { createContext, useContext, useMemo } from "react";
import { useSettingController } from "./useSettingController";

interface SettingProviderProps {
  children: React.ReactNode;
  accountType: "company" | "individual";
  user?: {
    id?: string;
  };
}

const SettingContext = createContext<any>(null);

export const SettingProvider = ({
  children,
  accountType,
  user,
}: SettingProviderProps) => {
  const controller = useSettingController(accountType, user);

  const contextValue = useMemo(() => controller, [controller]);

  return (
    <SettingContext.Provider key={user?.id} value={contextValue}>
      {children}
    </SettingContext.Provider>
  );
};

export const useSetting = () => {
  const context = useContext(SettingContext);

  if (!context) {
    throw new Error("useSetting must be used within a SettingProvider");
  }

  return context;
};
